import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  radioGroup: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(1.5),
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        marginBottom: theme.spacing(3),
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        marginBottom: theme.spacing(1.5),
      }),
    },
  },
  radioLabel: {
    marginRight: 'auto',
    '& .MuiTypography-root': {
      fontSize: 18,
      [theme.breakpoints.down('md')]: {
        fontSize: 16,
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          fontSize: 16,
        }),
      },
    },
  },
  radioItem: {
    color: '#C6CAC6',
    padding: 8,
    '&$checked': { color: theme.palette.primary1 },
    [theme.breakpoints.down('md')]: {
      padding: 5,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        padding: 5,
      }),
    },
  },
  editRequestButton: {
    marginTop: -10,
    padding: 4,
    width: 'fit-content',
  },
  noMethods: {
    color: '#c5203f',
    marginBottom: theme.spacing(2),
    width: 530,
    [theme.breakpoints.down('md')]: {
      width: 400,
    },
    [theme.breakpoints.down('sm')]: {
      width: 'initial',
    },
  },
}));
